<template>
  <div>
    <show-code :code="fieldInfoList"></show-code>
    <show-code :code="preResult"></show-code>
    <load-block :load="!load"></load-block>
    <the-edit-page
      :scheme="scheme"
      :isEntity="true"
      :loadData="loadData"
      v-if="load"
      :title="title"
      :pageMode="pageMode"
    >
      <the-controls-edit-page
        :scheme="scheme"
        :loadData="loadData"
        :saveData="saveData"
        :pathBack="pathBack"
        :show-history="!($route.name == routeNameCreate)"
        :open-history="openHistory"
        :hasHistory="false"
        :configName="roleParams"
        :roleName="roleParams"
        :pageMode="pageMode"
        :wait="wait"
      ></the-controls-edit-page>
    </the-edit-page>
    <!-- <history-person-contact
      v-if="!($route.name == 'CreateContact')"
      :modals="modals"
      :toggleModal="toggleModal"
      :closeHistory="closeHistory"
    ></history-person-contact> -->
  </div>
</template>
<script>
import TheEditPage from "../../TheEditPage.vue";
import { SABRE_REMARK } from "./store/type";
import { CREATE, READ, UPDATE } from "../../../store/type";
import TheControlsEditPage from "../../TheControlsEditPage.vue";
import clearReactive from "../../../helpers/clearReactive";
import ShowCode from "../../shared/ShowCode.vue";
import convertFieldInfoListToScheme from "../../../helpers/converters/convetFieldInfoListToScheme";
import clearNull from "../../../../src/helpers/clearNull";
import { mapState } from "vuex";

import { TYPE_ERRORS } from "../../../constant";
import notify from "../../../helpers/notify/notify";
import LoadBlock from "../../shared/LoadBlock.vue";
import { checkValidate } from "../../../mixins/validate/checkValidate";
import HistoryPersonContact from "../history/HistoryPersonContact.vue";
import { pageMode } from "../../../mixins/editPage/pageMode";
import { NAME_OBJECT } from "../../../RoleConstanans";
export default {
  name: "EditPageSabreRemarkContract",
  components: {
    HistoryPersonContact,
    LoadBlock,
    ShowCode,
    TheControlsEditPage,
    TheEditPage
  },
  mixins: [checkValidate, pageMode],
  data() {
    return {
      wait: false,
      scheme: {},
      loadData: null,
      fieldInfoList: null,
      preResult: null,
      load: true,
      modals: {
        history: false
      },
      routeNameShow: null,
      routeNameCreate: null
    };
  },
  computed: {
    ...mapState({
      lang: state => state.common.lang
    }),
    title() {
      return this.pageTitle(
        this.$t("Просмотр ремарок SABRE"),
        this.$t("Создание ремарок SABRE"),
        this.$t("Редактирование ремарок SABRE")
      );
    },
    pathBack() {
      return `/contract/${this.$route.params.ContractId}/edit`;
    },
    meta() {
      return this.$route.meta;
    },
    roleParams() {
      return NAME_OBJECT.sabreRemark;
    }
  },
  watch: {
    lang() {
      this.initData();
    }
  },
  created() {
    this.initData();
    this.routeNameShow = this.meta.routeNameShow;
    this.routeNameCreate = this.meta.routeNameCreate;
  },
  methods: {
    toggleModal(name) {
      this.modals[name] = !this.modals[name];
    },
    openHistory() {
      this.toggleModal("history");
    },
    closeHistory() {
      this.toggleModal("history");
      this.initData();
    },

    initData() {
      this.load = false;
      this.$store
        .dispatch(SABRE_REMARK + READ, {
          SubjectParamId: this.$route.params.SubjectParamId || "0",
          self: this,
          SubjectId: this.$route.params.ContractId,
          ParamCode: "SabreRemark"
        })
        .then(res => {
          this.loadData = res.object;
          let fieldInfoList = res.fieldInfoList;

          this.fieldInfoList = fieldInfoList; //del in future
          this.scheme.configForm = convertFieldInfoListToScheme({
            fieldInfoList,
            hasLang: false
          });
          this.preResult = convertFieldInfoListToScheme({
            fieldInfoList,
            hasLang: false
          }); //del in future
          this.scheme.configForm = this.scheme.configForm.map(item => {
            if (item.fieldName === "value") {
              return {
                ...item,
                validationRule: {
                  required: true,
                  regex: "^[^а-яА-Я]+$"
                }
              };
            }
            return item;
          });

          // this.loadData.subjectId = this.$route.params.PersonId;
          // this.loadData.holderId  = this.$route.params.PersonId;
          this.load = true;
        });
    },
    saveData() {
      if (this.validateData() == false) {
        return;
      }
      let saveData = clearReactive(this.loadData);
      saveData = clearNull(saveData);
      this.wait = true;

      const Action = this.$route.params.SubjectParamId ? UPDATE : CREATE;

      this.$store
        .dispatch(SABRE_REMARK + Action, {
          SubjectParamId: this.$route.params.SubjectParamId,
          saveData: saveData,
          self: this,
          SubjectId: this.$route.params.ContractId
        })
        .then(res => {
          this.wait = false;
          if (res.errors.length == 0) {
            notify(this, this.$t("Успешно"), TYPE_ERRORS.SUCCESS);
            this.$router.push({ path: this.pathBack });
          }
        })
        .catch(err => {
          console.error(err);
          this.wait = false;
        });
    }
  }
};
</script>
